import { createAction, handleActions } from 'redux-actions';
export const setLegInView = createAction('setLegInView');
export default handleActions({
    [setLegInView.toString()]: (_, { payload }) => payload
}, null);
